// src/config/roleAccess.js

export const roleAccess = {
    Coder: [
        "1.home",
        "2.list",
        "2.list2",
        "3.operations",
        "4.create_machine",
        "5.products1",
        "6.batches_temp",
        "6.batches",
        "6.batches_report",
        "6.batchesDetail",
        "shifts",
        "new_batch",
        "new_prod",
        "hardware",
        "activityType",
        "batchRep",
        "operator_list",
        "new_operator",
        "oee_rep",
        "activity_type_rep",
        "screen1",
        "screen_total",
        "help"
    ],
    Administrator: [
        "1.home",
        "2.list",
        "2.list2",
        "3.operations",
        "4.create_machine",
        "5.products1",
        "6.batches",
        "shifts",
        "new_batch",
        "new_prod",
        "activityType",
        "batchRep",
        "activityList",
        "shift_report",
        "operator_list",
        "new_operator",
        "6.batches_temp",
        "oee_rep",
        "activity_type_rep",
        "screen1",
        "screen_total",
        "help"
    ],
    Operator: [
        "1.home",
        //"6.batches",
        "6.batches_temp",
        "6.batches_report",
        "new_batch",
        "activity_report",
        "help"
    ],
    Instalator: [
        "1.home",
        "help"
    ]
};
